export default function NavbarIconButton({ icon, alt, isActive, onClick }) {
  return (
    <div
      className={`dash-component__navbar-element-svg navbar-element neomorphism-button ${
        isActive ? "active" : ""
      }`}
      onClick={onClick}
    >
      <img src={icon} alt={alt} width="24" height="24" />
    </div>
  );
}
